import { render, staticRenderFns } from "./Home-old.vue?vue&type=template&id=42194752&scoped=true"
import script from "./Home-old.vue?vue&type=script&lang=js"
export * from "./Home-old.vue?vue&type=script&lang=js"
import style0 from "./Home-old.vue?vue&type=style&index=0&id=42194752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42194752",
  null
  
)

export default component.exports